module.exports = __webpack_public_path__ + "img/CamChange.f3ae13b3.png";